import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>Rameshwaram Villa</h3>
          <p>Experience luxury and comfort in the heart of Pathankot</p>
        </div>
        
        <div className="footer-section">
          <h4>Quick Links</h4>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/about">About</a></li>
            <li><a href="/services">Services</a></li>
            <li><a href="/photos">Photos</a></li>
            <li><a href="/contact">Contact</a></li>
          </ul>
        </div>
        
        <div className="footer-section">
          <h4>Contact Info</h4>
          <p>📍 Pathankot, Punjab, India</p>
          <p>📞 +91 9205279444</p>
          <p>✉️ info@rameshwaramvilla.com</p>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>&copy; 2025 Rameshwaram Villa. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer; 